import { render, staticRenderFns } from "./priceOrder.vue?vue&type=template&id=dd7859ba&scoped=true&"
import script from "./priceOrder.vue?vue&type=script&lang=js&"
export * from "./priceOrder.vue?vue&type=script&lang=js&"
import style0 from "./priceOrder.vue?vue&type=style&index=0&id=dd7859ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7859ba",
  null
  
)

export default component.exports